import { Icons } from '@/components/icons';
import {
  defaultRelationFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  ApartmentContractConfig,
  IndustrialPremisesConfig,
  OtherContractConfig,
  OutdoorSectionContractConfig,
  ParkingSpotContractConfig,
  TenantConfig,
} from '@pigello/pigello-matrix';
import baseFilters, {
  baseGlobalRealEstatesFilter,
  baseTagFilter,
} from '../../filters';
import baseContractFilters, {
  STATUS_FILTER_ID,
  SUB_LEASE_ID,
  GUARANTOR_ID,
} from '../components/base-contract-filters';

const otherContractFilters: Filter[] = [
  {
    ...defaultRelationFilter,
    title: OtherContractConfig.fields.tenantCounterpart.verboseName,
    relationModelName: TenantConfig.modelName,
    externalFieldName:
      OtherContractConfig.fields.tenantCounterpart.externalFieldName,
    icon: Icons.tenant,
  },
  {
    ...defaultRelationFilter,
    title: OtherContractConfig.fields.mainApartmentContract.verboseName,
    relationModelName: ApartmentContractConfig.modelName,
    externalFieldName:
      OtherContractConfig.fields.mainApartmentContract.externalFieldName,
    icon: Icons.apartmentcontract,
  },
  {
    ...defaultRelationFilter,
    title:
      OtherContractConfig.fields.mainIndustrialPremisesContract.verboseName,
    relationModelName: IndustrialPremisesConfig.modelName,
    externalFieldName:
      OtherContractConfig.fields.mainIndustrialPremisesContract
        .externalFieldName,
    icon: Icons.industrialpremisescontract,
  },
  {
    ...defaultRelationFilter,
    title: OtherContractConfig.fields.mainParkingspotContract.verboseName,
    relationModelName: ParkingSpotContractConfig.modelName,
    externalFieldName:
      OtherContractConfig.fields.mainParkingspotContract.externalFieldName,
    icon: Icons.parkingspotcontract,
  },
  {
    ...defaultRelationFilter,
    title: OtherContractConfig.fields.mainOutdoorsectionContract.verboseName,
    relationModelName: OutdoorSectionContractConfig.modelName,
    externalFieldName:
      OtherContractConfig.fields.mainOutdoorsectionContract.externalFieldName,
    icon: Icons.outdoorsectioncontract,
  },
  ...baseGlobalRealEstatesFilter,
  ...baseContractFilters
    .filter((f) => f.id !== 'contract_tenant')
    .map((contractFilter) => {
      if (contractFilter.id === STATUS_FILTER_ID) {
        return {
          ...contractFilter,
          enumChoices: contractFilter.enumChoices?.filter(
            (choice) => choice.id !== GUARANTOR_ID && choice.id !== SUB_LEASE_ID
          ),
        };
      }
      return contractFilter;
    }),
  ...baseTagFilter,
  ...baseFilters,
];

export default otherContractFilters;
